import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import customAxios from './custom/axios-custom';
import VueSession from './custom/vue-session-custom';
import routes from './custom/routes';
import middleware from './custom/middleware';
import permission from './custom/permission.json';
import globalFilters from './custom/vue-global-filters';
import globalDirectives from './custom/vue-global-directives';
import i18n from "./custom/i18n";
import VeeValidate from './custom/vue-vee-custom';
import "@/sass/demo/demo3/style.scss";
// El JS de metronic (toggle de aside, header sticky, jQuery + Bootstrap JS +
// bootstrap-select + date-pickers) ahora se carga bajo demanda solo cuando el
// usuario está autenticado, ver App.vue -> loadAdminAssets().
import moment from 'moment';
import { createPinia, PiniaVuePlugin } from 'pinia';
// Importar parches de seguridad
import '../security-patches.js';
// Importar mitigación para CVE-2025-69873 (ajv ReDoS)
import './custom/ajv-security.js';

Vue.use(VueRouter);
Vue.use(globalDirectives);
Vue.use(globalFilters);
Vue.use(PiniaVuePlugin);

Vue.use(VueSession, {
    persist: true
});

Vue.use(middleware, permission);

const pinia = createPinia();
const router = new VueRouter({ mode: 'history', routes: routes });

customAxios.interceptors.response.use(
    function (response) {
        Vue._session.set('lastCheck', moment().format('YYYY-MM-DD hh:mm A'));
        Vue._session.set('checkTimeOut', false);
        return response;
    },
    function (error) {
        if (error.response.status == 401 && router.currentRoute.name !== 'Login' && !router.currentRoute.meta.isPublic) {
            Vue._session.set('TOKEN', '');
            router.push('/');
        }
        return error.response;
    }
);
customAxios.interceptors.request.use(function (config) {
    if (!Vue._session.exists()) {
        Vue._session.start();
    }
    config.headers['SESSION'] = Vue._session.id().replace('sess:', '');
    if (i18n._vm.$root.$root.locale) {
        config.headers['lang'] = i18n._vm.$root.$root.locale;
    }

    if (config.baseURL.indexOf(['localhost']) > -1) {
        config.headers['DEBUG'] = true;
    }
    if ((Vue._session.get('TOKEN') || '').length == 16 && (config.headers['TOKEN'] || '').length == 0) {
        config.headers['TOKEN'] = Vue._session.get('TOKEN');
        config.headers['USER'] = Vue._session.get("user");
    }
    return config;
}, function (err) {
    return Promise.reject(err);
});

router.beforeEach((to, from, next) => {
    const lang = (to.params.lang || (Vue._session.get('lang') || 'en'));
    i18n._vm.$root.$root.locale = lang;
    VeeValidate.Validator.locale = lang;
    document.documentElement.lang = lang;

    if (to.meta.isPublic) {
        if (to.name == "Login" && (Vue._session.get('TOKEN') || '').length == 16) {
            if (Vue.$middleware("repricing", "read")) {
                next("/re-pricing");
            } else {
                next("/dashboard");
            }
        } else {
            next();
        }
    } else {
        if (Vue._session.exists() && (Vue._session.get('TOKEN') || '').length == 16) {
            const isChangePassword = Vue._session.get('changePassword') == 1;
            if (isChangePassword && to.name !== 'MyAccount') {
                next({ name: 'MyAccount' });
            } else {
                next();
            }
        } else {
            next('/');
        }
    }
});

Vue.config.productionTip = false;
Vue.prototype.$env = process.env;
Vue.prototype.axios = customAxios;

Vue.filter('t', function (value) {
    return i18n.t(value)
});

Vue.mixin({
    methods: {
        baseUrlAxios: function () {
            return 'https://' + this.axios.defaults.baseURL.replace('http://', '')
                .replace('https://', '')
                .replace('www.', '');
        },
        baseUrlApi: function () {
            return 'https://' + this.baseUrlAxios()
                .replace('https://', '')
                .split(/[/?#]/)[0] + '/';
        }
    }
})

new Vue({
    mounted: function () {
        setInterval(() => {
            if (router.currentRoute.fullPath !== '/') {
                let lastCheck = moment(Vue._session.get('lastCheck')),
                    check = Vue._session.get('checkTimeOut'),
                    duration = moment.duration(moment().diff(lastCheck)).asMinutes();
                if (duration >= 10) {
                    this.axios.post("timeOut", { 'reset': check }).then(response => {
                        if (response.data.STATUS == "OK") {
                            Vue._session.set('lastCheck', moment().format('YYYY-MM-DD hh:mm A'));
                            Vue._session.set('checkTimeOut', false);
                        }
                    });
                }
            }
        }, (5 * 60 * 1000));
        document.addEventListener("click", function () {
            Vue._session.set('checkTimeOut', true);
        });
    },
    render: h => h(App),
    router,
    i18n,
    pinia
}).$mount('#app')